import React, { useEffect, useState } from "react"
import { Link, navigate } from "gatsby"
import { useAnimation, motion, AnimatePresence } from "framer-motion"
import { useInView } from "react-intersection-observer"

const motionSection = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      staggerChildren: 0.3,
      staggerDirection: 1,
      delay: 0.3,
      ease: [0.38, 0.005, 0.215, 1],
      when: "beforeChildren",
    },
  },
}
const title = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}
const underline = {
  hidden: {
    // opacity: 0,
    width: 0,
  },
  visible: {
    opacity: 1,
    // right: 0,
    width: "100%",
    transition: {
      duration: 0.3,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}
const motionItems = {
  hidden: {
    opacity: 0,
    y: 20,
    // rotate: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}

const franchiseForm = ({ block }) => {
  const { heading, text } = block

  const controls = useAnimation()
  const [ref, inView] = useInView()

  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView])

  //form handling
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    cellPhone: "",
    textOptIn: false,
    phone: "",
    email: "",
    bestContactTime: "00:00",
    address1: "",
    address2: "",
    city: "",
    state: "",
    country: "",
    firstChoice: "",
    secondChoice: "",
    thirdChoice: "",
    timing: "",
    investmentCapital: "",
    netWorth: "",
    interestLevel: "",
    referralSource: "",
    comments: "",
    "bot-field": ""
  })

  const handleChange = e => {
    const { name, value } = e.target
    // const { value } = e.target.type === "checkbox" ? e.target.checked : e.target;

    let finalValue = e.target.type === "checkbox" ? e.target.checked : value



    setFormData({ ...formData, [name]: finalValue })
  }

  console.log("formData", formData)

  //form validations
  const [errors, setErrors] = useState({})

  const validate = formData => {
    let formErrors = {}
    if (!formData.firstName) {
      formErrors.firstName = "Rrequired"
    }
    if (!formData.lastName) {
      formErrors.lastName = "Required"
    }
    if (!formData.email) {
      formErrors.email = "Required"
    }
    if (!formData.phone) {
      formErrors.phone = "Required"
    }
    if (!formData.bestContactTime) {
      formErrors.bestContactTime = "Required"
    }
    if (!formData.state) {
      formErrors.state = "Required"
    }
    if (!formData.firstChoice) {
      formErrors.firstChoice = "Required"
    }
    if (!formData.secondChoice) {
      formErrors.secondChoice = "Required"
    }
    if (!formData.thirdChoice) {
      formErrors.thirdChoice = "Required"
    }
    if (!formData.investmentCapital) {
      formErrors.investmentCapital = "Required"
    }
    if (!formData.netWorth) {
      formErrors.netWorth = "Required"
    }
    if (!formData.interestLevel) {
      formErrors.interestLevel = "Required"
    }

    return formErrors
  }

  const [isSubmitted, setIsSubmitted] = useState(false)

  const handleSubmit = e => {
    setErrors(validate(formData))
    setIsSubmitted(true)
    e.preventDefault()
  }

  const encode = data => {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&")
  }

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitted) {
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({ "form-name": "franchise", ...formData }),
      })
        .then(() => setIsSubmitted(false))
        .then(() =>
          setFormData({ 
            firstName: "",
            lastName: "",
            cellPhone: "",
            textOptIn: false,
            phone: "",
            email: "",
            address1: "",
            address2: "",
            city: "",
            state: "",
            country: "",
            firstChoice: "",
            secondChoice: "",
            thirdChoice: "",
            timing: "",
            investmentCapital: "",
            netWorth: "",
            interestLevel: "",
            referralSource: "",
            comments: "",
            bestContactTime: "00:00",
            "bot-field": ""
          })
        )
        .then(() => navigate("/thank-you"))
        .catch(error => alert(error))
    }
  }, [errors, formData, isSubmitted])
  console.log(errors, formData)

  return (
    <motion.section
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={motionSection}
    >
      <div className="p-6 lg:p-12 max-w-screen-md mx-auto">
        {heading && (
          <h2 className="h2 text-center relative w-fit mx-auto mb-8">
            <motion.div variants={title}>{heading}</motion.div>
            <motion.div
              variants={underline}
              className="section-heading__underline bg-orange-400 h-2 w-full absolute -bottom-4 left-0"
            />
          </h2>
        )}
        {text && <p>{text}</p>}

        <form name="franchise" method="post" className="grid grid-cols-1 gap-6" data-netlify="true"
          data-netlify-honeypot="bot-field"
          onSubmit={handleSubmit}>
          <input type="hidden" name="form-name" value="franchise" />
          <input name="bot-field" type="hidden" onChange={handleChange} />

          <h3 className="h3 mt-8">Contact info</h3>

          <div className="grid grid-cols-2 gap-4">
            <label className="block">
              <span>First name</span>
              <input
                type="text"
                id="firstName"
                name="firstName"
                className="
                  mt-1
                  block
                  w-full
                  rounded-md
                  bg-orange-100
                  border-transparent
                  focus:border-gray-500 focus:bg-white focus:ring-0
                "
                value={formData.firstName}
                onChange={handleChange}
                placeholder=""
                required
              />
            </label>
            <label className="block">
              <span>Last name</span>
              <input
                type="text"
                id="lastName"
                name="lastName"
                className="
                  mt-1
                  block
                  w-full
                  rounded-md
                  bg-orange-100
                  border-transparent
                  focus:border-gray-500 focus:bg-white focus:ring-0
                "
                value={formData.lastName}
                onChange={handleChange}
                placeholder=""
                required
              />
            </label>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col gap-2">
              <label className="block">
                <span>Cell Phone</span>
                <input
                  type="tel"
                  className="
                      mt-1
                      block
                      w-full
                      rounded-md
                      bg-orange-100
                      border-transparent
                      focus:border-gray-500 focus:bg-white focus:ring-0
                    "
                  id="cellPhone"
                  name="cellPhone"
                  placeholder="213-222-5555"
                  value={formData.cellPhone}
                  onChange={handleChange}
                />
              </label>
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  name="textOptIn"
                  id="textOptIn"
                  className="
                  rounded
                  bg-orange-200
                  border-transparent
                  focus:border-transparent focus:bg-orange-500
                  text-gray-700
                  focus:ring-1 focus:ring-offset-2 focus:ring-gray-500"
                  // value={formData.textOptIn}
                  onChange={handleChange}
                  checked={formData.textOptIn}
                />
                <span className="ml-2">Opt in for text contact</span>
              </label>
            </div>
            <label className="block">
              <span>Phone</span>
              <input
                type="tel"
                className="
                    mt-1
                    block
                    w-full
                    rounded-md
                    bg-orange-100
                    border-transparent
                    focus:border-gray-500 focus:bg-white focus:ring-0"
                id="phone"
                name="phone"
                placeholder="213-222-5555"
                required
                value={formData.phone}
                onChange={handleChange}
              />
            </label>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <label className="block">
              <span>Email address</span>
              <input
                type="email"
                className="
                      mt-1
                      block
                      w-full
                      rounded-md
                      bg-orange-100
                      border-transparent
                      focus:border-gray-500 focus:bg-white focus:ring-0
                    "
                placeholder="john@example.com"
                id="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
              />
            </label>
            <label className="block">
              <span>Best time to call</span>
              <input
                type="time"
                className="
                      mt-1
                      block
                      w-full
                      rounded-md
                      bg-orange-100
                      border-transparent
                      focus:border-gray-500 focus:bg-white focus:ring-0
                    "
                id="bestContactTime"
                name="bestContactTime"
                value={formData.bestContactTime}
                onChange={handleChange}
              />
            </label>
          </div>

          <label className="block">
            <span>Address</span>
            <input
              type="text"
              className="
                    mt-1
                    block
                    w-full
                    rounded-md
                    bg-orange-100
                    border-transparent
                    focus:border-gray-500 focus:bg-white focus:ring-0
                  "
              id="address1"
              name="address1"
              value={formData.address1}
              onChange={handleChange}
            />
          </label>

          <div className="grid grid-cols-2 gap-4">
            <label className="block">
              <span>Address 2</span>
              <input
                type="text"
                className="
                      mt-1
                      block
                      w-full
                      rounded-md
                      bg-orange-100
                      border-transparent
                      focus:border-gray-500 focus:bg-white focus:ring-0
                    "
                id="address2"
                name="address2"
                value={formData.address2}
                onChange={handleChange}
              />
            </label>
            <label className="block">
              <span>City</span>
              <input
                type="text"
                className="
                      mt-1
                      block
                      w-full
                      rounded-md
                      bg-orange-100
                      border-transparent
                      focus:border-gray-500 focus:bg-white focus:ring-0
                    "
                id="city"
                name="city"
                value={formData.city}
                onChange={handleChange}
              />
            </label>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <label className="block">
              <span>State</span>
              <select
                type="select"
                className="
                      mt-1
                      block
                      w-full
                      rounded-md
                      bg-orange-100
                      border-transparent
                      focus:border-gray-500 focus:bg-white focus:ring-0
                    "
                id="state"
                name="state"
                required
                value={formData.state}
                onChange={handleChange}
              >
                <option value=""></option>
                <option value="AL">Alabama</option>
                <option value="AK">Alaska</option>
                <option value="AZ">Arizona</option>
                <option value="AR">Arkansas</option>
                <option value="CA">California</option>
                <option value="CO">Colorado</option>
                <option value="CT">Connecticut</option>
                <option value="DE">Delaware</option>
                <option value="DC">District Of Columbia</option>
                <option value="FL">Florida</option>
                <option value="GA">Georgia</option>
                <option value="HI">Hawaii</option>
                <option value="ID">Idaho</option>
                <option value="IL">Illinois</option>
                <option value="IN">Indiana</option>
                <option value="IA">Iowa</option>
                <option value="KS">Kansas</option>
                <option value="KY">Kentucky</option>
                <option value="LA">Louisiana</option>
                <option value="ME">Maine</option>
                <option value="MD">Maryland</option>
                <option value="MA">Massachusetts</option>
                <option value="MI">Michigan</option>
                <option value="MN">Minnesota</option>
                <option value="MS">Mississippi</option>
                <option value="MO">Missouri</option>
                <option value="MT">Montana</option>
                <option value="NE">Nebraska</option>
                <option value="NV">Nevada</option>
                <option value="NH">New Hampshire</option>
                <option value="NJ">New Jersey</option>
                <option value="NM">New Mexico</option>
                <option value="NY">New York</option>
                <option value="NC">North Carolina</option>
                <option value="ND">North Dakota</option>
                <option value="OH">Ohio</option>
                <option value="OK">Oklahoma</option>
                <option value="OR">Oregon</option>
                <option value="PA">Pennsylvania</option>
                <option value="RI">Rhode Island</option>
                <option value="SC">South Carolina</option>
                <option value="SD">South Dakota</option>
                <option value="TN">Tennessee</option>
                <option value="TX">Texas</option>
                <option value="UT">Utah</option>
                <option value="VT">Vermont</option>
                <option value="VA">Virginia</option>
                <option value="WA">Washington</option>
                <option value="WV">West Virginia</option>
                <option value="WI">Wisconsin</option>
                <option value="WY">Wyoming</option>
              </select>
            </label>
            <label className="block">
              <span>Country</span>
              <select
                type="select"
                className="
                      mt-1
                      block
                      w-full
                      rounded-md
                      bg-orange-100
                      border-transparent
                      focus:border-gray-500 focus:bg-white focus:ring-0
                    "
                id="country"
                name="country"
                value={formData.country}
                onChange={handleChange}
              >
                <option value=""></option>
                <option value="US">United States</option>
              </select>
            </label>
          </div>

          <h3 className="h3 mt-8">Preferred Area</h3>
          <div className="grid grid-cols-3 gap-4">
            <label className="block">
              <span>1st Choice</span>
              <select
                type="select"
                className="
                      mt-1
                      block
                      w-full
                      rounded-md
                      bg-orange-100
                      border-transparent
                      focus:border-gray-500 focus:bg-white focus:ring-0
                    "
                id="firstChoice"
                name="firstChoice"
                value={formData.firstChoice}
                onChange={handleChange}
                required
              >
                <option value=""></option>
                <option value="AL">Alabama</option>
                <option value="AK">Alaska</option>
                <option value="AZ">Arizona</option>
                <option value="AR">Arkansas</option>
                <option value="CA">California</option>
                <option value="CO">Colorado</option>
                <option value="CT">Connecticut</option>
                <option value="DE">Delaware</option>
                <option value="DC">District Of Columbia</option>
                <option value="FL">Florida</option>
                <option value="GA">Georgia</option>
                <option value="HI">Hawaii</option>
                <option value="ID">Idaho</option>
                <option value="IL">Illinois</option>
                <option value="IN">Indiana</option>
                <option value="IA">Iowa</option>
                <option value="KS">Kansas</option>
                <option value="KY">Kentucky</option>
                <option value="LA">Louisiana</option>
                <option value="ME">Maine</option>
                <option value="MD">Maryland</option>
                <option value="MA">Massachusetts</option>
                <option value="MI">Michigan</option>
                <option value="MN">Minnesota</option>
                <option value="MS">Mississippi</option>
                <option value="MO">Missouri</option>
                <option value="MT">Montana</option>
                <option value="NE">Nebraska</option>
                <option value="NV">Nevada</option>
                <option value="NH">New Hampshire</option>
                <option value="NJ">New Jersey</option>
                <option value="NM">New Mexico</option>
                <option value="NY">New York</option>
                <option value="NC">North Carolina</option>
                <option value="ND">North Dakota</option>
                <option value="OH">Ohio</option>
                <option value="OK">Oklahoma</option>
                <option value="OR">Oregon</option>
                <option value="PA">Pennsylvania</option>
                <option value="RI">Rhode Island</option>
                <option value="SC">South Carolina</option>
                <option value="SD">South Dakota</option>
                <option value="TN">Tennessee</option>
                <option value="TX">Texas</option>
                <option value="UT">Utah</option>
                <option value="VT">Vermont</option>
                <option value="VA">Virginia</option>
                <option value="WA">Washington</option>
                <option value="WV">West Virginia</option>
                <option value="WI">Wisconsin</option>
                <option value="WY">Wyoming</option>
              </select>
            </label>
            <label className="block">
              <span>2nd Choice</span>
              <select
                type="select"
                className="
                      mt-1
                      block
                      w-full
                      rounded-md
                      bg-orange-100
                      border-transparent
                      focus:border-gray-500 focus:bg-white focus:ring-0
                    "
                id="secondChoice"
                name="secondChoice"
                required
                value={formData.secondChoice}
                onChange={handleChange}
              >
                <option value=""></option>
                <option value="AL">Alabama</option>
                <option value="AK">Alaska</option>
                <option value="AZ">Arizona</option>
                <option value="AR">Arkansas</option>
                <option value="CA">California</option>
                <option value="CO">Colorado</option>
                <option value="CT">Connecticut</option>
                <option value="DE">Delaware</option>
                <option value="DC">District Of Columbia</option>
                <option value="FL">Florida</option>
                <option value="GA">Georgia</option>
                <option value="HI">Hawaii</option>
                <option value="ID">Idaho</option>
                <option value="IL">Illinois</option>
                <option value="IN">Indiana</option>
                <option value="IA">Iowa</option>
                <option value="KS">Kansas</option>
                <option value="KY">Kentucky</option>
                <option value="LA">Louisiana</option>
                <option value="ME">Maine</option>
                <option value="MD">Maryland</option>
                <option value="MA">Massachusetts</option>
                <option value="MI">Michigan</option>
                <option value="MN">Minnesota</option>
                <option value="MS">Mississippi</option>
                <option value="MO">Missouri</option>
                <option value="MT">Montana</option>
                <option value="NE">Nebraska</option>
                <option value="NV">Nevada</option>
                <option value="NH">New Hampshire</option>
                <option value="NJ">New Jersey</option>
                <option value="NM">New Mexico</option>
                <option value="NY">New York</option>
                <option value="NC">North Carolina</option>
                <option value="ND">North Dakota</option>
                <option value="OH">Ohio</option>
                <option value="OK">Oklahoma</option>
                <option value="OR">Oregon</option>
                <option value="PA">Pennsylvania</option>
                <option value="RI">Rhode Island</option>
                <option value="SC">South Carolina</option>
                <option value="SD">South Dakota</option>
                <option value="TN">Tennessee</option>
                <option value="TX">Texas</option>
                <option value="UT">Utah</option>
                <option value="VT">Vermont</option>
                <option value="VA">Virginia</option>
                <option value="WA">Washington</option>
                <option value="WV">West Virginia</option>
                <option value="WI">Wisconsin</option>
                <option value="WY">Wyoming</option>
              </select>
            </label>
            <label className="block">
              <span>3rd Choice</span>
              <select
                type="select"
                className="
                      mt-1
                      block
                      w-full
                      rounded-md
                      bg-orange-100
                      border-transparent
                      focus:border-gray-500 focus:bg-white focus:ring-0
                    "
                id="thirdChoice"
                name="thirdChoice"
                value={formData.thirdChoice}
                onChange={handleChange}
                required
              >
                <option value=""></option>
                <option value="AL">Alabama</option>
                <option value="AK">Alaska</option>
                <option value="AZ">Arizona</option>
                <option value="AR">Arkansas</option>
                <option value="CA">California</option>
                <option value="CO">Colorado</option>
                <option value="CT">Connecticut</option>
                <option value="DE">Delaware</option>
                <option value="DC">District Of Columbia</option>
                <option value="FL">Florida</option>
                <option value="GA">Georgia</option>
                <option value="HI">Hawaii</option>
                <option value="ID">Idaho</option>
                <option value="IL">Illinois</option>
                <option value="IN">Indiana</option>
                <option value="IA">Iowa</option>
                <option value="KS">Kansas</option>
                <option value="KY">Kentucky</option>
                <option value="LA">Louisiana</option>
                <option value="ME">Maine</option>
                <option value="MD">Maryland</option>
                <option value="MA">Massachusetts</option>
                <option value="MI">Michigan</option>
                <option value="MN">Minnesota</option>
                <option value="MS">Mississippi</option>
                <option value="MO">Missouri</option>
                <option value="MT">Montana</option>
                <option value="NE">Nebraska</option>
                <option value="NV">Nevada</option>
                <option value="NH">New Hampshire</option>
                <option value="NJ">New Jersey</option>
                <option value="NM">New Mexico</option>
                <option value="NY">New York</option>
                <option value="NC">North Carolina</option>
                <option value="ND">North Dakota</option>
                <option value="OH">Ohio</option>
                <option value="OK">Oklahoma</option>
                <option value="OR">Oregon</option>
                <option value="PA">Pennsylvania</option>
                <option value="RI">Rhode Island</option>
                <option value="SC">South Carolina</option>
                <option value="SD">South Dakota</option>
                <option value="TN">Tennessee</option>
                <option value="TX">Texas</option>
                <option value="UT">Utah</option>
                <option value="VT">Vermont</option>
                <option value="VA">Virginia</option>
                <option value="WA">Washington</option>
                <option value="WV">West Virginia</option>
                <option value="WI">Wisconsin</option>
                <option value="WY">Wyoming</option>
              </select>
            </label>
          </div>

          <h3 className="h3 mt-8">Business logistics</h3>

          <div className="grid grid-cols-2 gap-4">
            <label className="block">
              <span>Timing</span>
              <select
                type="select"
                className="
                        mt-1
                        block
                        w-full
                        rounded-md
                        bg-orange-100
                        border-transparent
                        focus:border-gray-500 focus:bg-white focus:ring-0
                      "
                id="timing"
                name="timing"
                value={formData.timing}
                onChange={handleChange}
              >
                <option value=""></option>
                <option value="1-3 months">1-3 months</option>
                <option value="3-6 months">3-6 months</option>
                <option value="6-12 months">6-12 months</option>
                <option value="12 months or more">6-12 months or more</option>
              </select>
            </label>

            <label className="block">
              <span>Cash/Liquid Capital to Invest</span>
              <select
                type="select"
                className="
                        mt-1
                        block
                        w-full
                        rounded-md
                        bg-orange-100
                        border-transparent
                        focus:border-gray-500 focus:bg-white focus:ring-0
                      "
                id="investmentCapital"
                name="investmentCapital"
                value={formData.investmentCapital}
                onChange={handleChange}
                required
              >
                <option value=""></option>
                <option value="<50K">Less than 50K</option>
                <option value="50-100K">50-100K</option>
                <option value="100K-250K">100K-250K</option>
                <option value="250-500K">250-500K</option>
                <option value="500K-1M">500K-1M</option>
                <option value="1M+">1M+</option>
              </select>
            </label>
          </div>
          

          <div className="grid grid-cols-2 gap-4">
          <label className="block">
            <span>Net Worth</span>
            <select
              type="select"
              className="
                      mt-1
                      block
                      w-full
                      rounded-md
                      bg-orange-100
                      border-transparent
                      focus:border-gray-500 focus:bg-white focus:ring-0
                    "
              id="netWorth"
              name="netWorth"
              required
              value={formData.netWorth}
              onChange={handleChange}
            >
              <option value=""></option>
              <option value="<50K">Less than 50K</option>
              <option value="50-100K">50-100K</option>
              <option value="100K-250K">100K-250K</option>
              <option value="250-500K">250-500K</option>
              <option value="500K-1M">500K-1M</option>
              <option value="1M+">1M+</option>
            </select>
          </label>

          <label className="block">
            <span>Interest level (1-10)</span>
            <select
              type="select"
              className="
                      mt-1
                      block
                      w-full
                      rounded-md
                      bg-orange-100
                      border-transparent
                      focus:border-gray-500 focus:bg-white focus:ring-0
                    "
              id="interestLevel"
              name="interestLevel"
              required
              value={formData.interestLevel}
              onChange={handleChange}
            >
              <option value=""></option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
            </select>
          </label>
          </div>
          
          <h3 className="h3 mt-8">Additional info</h3>

          <label className="block">
            <span>How did you hear about our franchise opportunity?</span>
            <textarea
              type="text"
              className="
                    mt-1
                    block
                    w-full
                    rounded-md
                    bg-orange-100
                    border-transparent
                    focus:border-gray-500 focus:bg-white focus:ring-0
                  "
              rows="3"
              id="referralSource"
              name="referralSource"
              value={formData.referralSource}
              onChange={handleChange}
            />
          </label>
          <label className="block">
            <span>Comments</span>
            <textarea
              type="text"
              className="
                    mt-1
                    block
                    w-full
                    rounded-md
                    bg-orange-100
                    border-transparent
                    focus:border-gray-500 focus:bg-white focus:ring-0
                  "
              rows="3"
              id="comments"
              name="comments"
              value={formData.comments}
              onChange={handleChange}
            />
          </label>


          <p>
            <input
              type="submit"
              value="Submit message"
              className="btn-secondary"
            />
          </p>
        </form>
      </div>
    </motion.section>
  )
}

export default franchiseForm
